import { EFeature } from 'app/types/rest/IUserMeta';
import { IApplicationState } from '../../../../../types/types';
import { isNewFeatureForUser } from '../isNewFeatureForUser';

export const getIsNewFeatureBoardSplitSettings = (
    state: IApplicationState
): boolean => {
    const isNewFeature = isNewFeatureForUser(state, EFeature.BOARD_SPLIT_SETTINGS);
    if (!isNewFeature) return false;

    return true;
};
